export default __webpack_public_path__ + "static/media/landing.27e24d2a.png";